<template>
    <div class="ts-widget" v-if="data && data.reviews && data.reviews.length >= 1 && dataLoaded && data.rating365 > 4">
        <div class="inner">
            <div class="badgex">
                <a class="icon" href="https://www.trustedshops.de/bewertung/info_X8E6C4E7BA7A8AB4C0482F062ADD8682E.html" target="_blank">
                    <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0AQMAAADxGE3JAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAADVJREFUeNrtwTEBAAAAwiD7p/ZZDGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOX0AAAEidG8rAAAAAElFTkSuQmCC"
                        data-src="https://cdn03.plentymarkets.com/7uqe7kjy3ccd/frontend/ts.webp"
                        alt=""
                        class="lazyload">
                </a>
                <div class="txt">
                    <strong class="rate">{{ data.rating365.toString().replace('.',',') }}</strong>
                    <span class="word" v-text="data.rating365 > 4 ? 'Sehr gut' : 'Gut'"></span>
                    <span class="rate-stars">
                        <span>
                            <span class="rate-blank">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </span>
                            <span class="rate-full" :style="'width:' + data.rating365 * 20 + '%'">
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </span>
                        </span>
                    </span>
                    <span class="total">({{ data.overallCount }})</span>
                </div>
                <!-- <div>{{ data.count365 }} <span>Bewertungen <span>(letzte 12 Mon.)</span></span></div>
                <div>{{ data.overallCount }} Bewertungen (gesamt)</div>
                <div><a href="https://www.trustedshops.de/bewertung/info_X8E6C4E7BA7A8AB4C0482F062ADD8682E.html" target="_blank">Stand: {{ data.calculatedAt.split('T')[0].split('-')[2] }}.{{ data.calculatedAt.split('T')[0].split('-')[1] }}.{{ data.calculatedAt.split('T')[0].split('-')[0] }}</a></div> -->
            </div>
        </div>
        <svg class="hide">
            <g id="svg_arrow"><rect width="20" height="20" rx="10"/><g transform="translate(7.75 6)"><path d="M4.457.707.707,4.457l3.75,3.75" transform="translate(-0.707 -0.707)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="1"/></g></g>
        </svg>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                data:[],
                dataLoaded: false,
            }
        },
        mounted() {
            var self = this,
            data = [];

            $.getJSON('/rest/cytTrustedShops/ratings').done(function( data ) {
                self.data = data;
                self.dataLoaded = true;
            })
        },
        methods: {
            update: function() {
                // only because shopbuilder
                var self = this;
                setTimeout(function() {
                    self.$refs.vueglider.glide.update();
                }, 500);
            }
        }
    }
</script>
